import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";


export class FeatureEndOfRound implements SimplePresentationRunner {
    private _mainTl:gsap.core.Timeline;

    shouldRun():boolean {
        return (DevilsCrossRoad.model.gameData.mode == GameMode.FREESPIN || DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        this._mainTl = gsap.timeline();
        controller.setSkipCallback(() => this.skip(controller));

        const allFeaturesToPlay: {values: number [], featureId:string, targetPos: PIXI.Point, featureIndex:number }  [] = DevilsCrossRoad.model.allFeaturesToPlay;

        allFeaturesToPlay.forEach((featureObject: {values: number [], featureId:string, targetPos: PIXI.Point, featureIndex:number }, idx) => {
            if(featureObject.featureIndex < 5) { // top
                this._mainTl.add(DevilsCrossRoad.cashFeatureHandler.playTopResultTimeline(featureObject.featureId, featureObject.featureIndex, featureObject.values,
                    featureObject.targetPos.y, featureObject.targetPos.x));
            }
            else { // right
                this._mainTl.add(DevilsCrossRoad.cashFeatureHandler.playRightResultTimeline(featureObject.featureId, featureObject.featureIndex - 5, featureObject.values,
                    featureObject.targetPos.y, featureObject.targetPos.x));
            }
        });


        this._mainTl.add(() => {
            DevilsCrossRoad.cashFeatureHandler.resetActiveFeatureList();
            DevilsCrossRoad.freespinUnlockAreas.clearAllTrackOneFeatAnims();
            //DevilsCrossRoad.freespinReelAreaView.resetEmptyReels(DevilsCrossRoad.model.data.stickyCoins, DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature);
            controller.finish();
        });

    }

    private skip(controller:SimplePresentationRunnerController):void{
        this._mainTl.totalProgress(1);
    }
}